import React from "react";
import { Quotation } from "../../../../stores/CoursePreviewStore/Types";

interface Props {
  quote: Quotation;
  className?: string;
  showDiscountComparison?: boolean;
}

interface CurrencyAmountProps {
  quote: Quotation;
  amount: string;
  showCurrencyCode?: boolean;
}

export const CurrencyAmount: React.FC<CurrencyAmountProps> = ({
  quote,
  amount,
  showCurrencyCode = true,
}) => {
  return (
    <>
      {quote?.currency}
      {amount}
      {quote?.currency_code && showCurrencyCode && (
        <span className="ccy-code">{quote.currency_code}</span>
      )}
    </>
  );
};

const PriceAmount: React.FC<Props> = ({
  quote,
  className = "",
  showDiscountComparison = true,
}) => {
  const originalAmount = quote?.original_price?.formatted_amount;
  const showDiscountedPrice =
    showDiscountComparison && quote?.discounted && originalAmount;

  return (
    <span className={`price-amount ${className}`.trim()}>
      {showDiscountedPrice && (
        <span className="strikethrough">
          <CurrencyAmount
            quote={quote}
            amount={originalAmount}
            showCurrencyCode={false}
          />
        </span>
      )}
      <strong>
        <CurrencyAmount quote={quote} amount={quote?.formatted_amount} />
      </strong>
    </span>
  );
};

export default PriceAmount;
